import { api } from '../api';
import { descargarComoXlsx, dispararExport, exportJobId, getExportLatest } from './exportaciones.service';

export interface FunnelStage {
  key: string;
  label: string;
  n: number;
  pct: number;
}
export interface EstadoConteo {
  key: string;
  label: string;
  n: number;
}
export interface LlamadaBucket {
  key: string;
  label: string;
  legajos: number;
  llamadas: number;
}
export interface SkytelFunnelDashboard {
  cohorte: number;
  funnel: FunnelStage[];
  proceso: EstadoConteo[];
  conversion: EstadoConteo[];
  llamadas: {
    legajosLlamados: number;
    totalLlamadas: number;
    promedio: number;
    nuncaLlamados: number;
    buckets: LlamadaBucket[];
  };
  atribucion: { ganadoSkytel: number; pagoMedicus: number };
}

export async function getSkytelFunnel(): Promise<SkytelFunnelDashboard> {
  const { data } = await api.get<SkytelFunnelDashboard>('/skytel-funnel');
  return data;
}

/**
 * Descarga (Excel) los legajos de un estado del funnel. Dispara el export,
 * espera a que termine y baja el .xlsx. `dimension`: funnel|proceso|conversion|llamadas.
 */
export async function descargarEstadoSkytel(dimension: string, valor: string): Promise<void> {
  const params = { dimension, valor };
  let job = await dispararExport('skytel-cohorte', params);
  for (let i = 0; i < 120 && job.estado === 'corriendo'; i++) {
    await new Promise((r) => setTimeout(r, 1500));
    const latest = await getExportLatest('skytel-cohorte', params);
    if (latest) job = latest;
  }
  if (job.estado !== 'terminado') {
    throw new Error(job.error || 'La descarga no terminó. Reintentá en unos segundos.');
  }
  await descargarComoXlsx(exportJobId(job), job.filename);
}
